export default "__VITE_ASSET__RMAw2Lrh__"